import { EActivityType } from '@constants';
import { Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { VideoPlayer } from '../VideoPlayer';

import { Description, Wrapper } from './ActivityPreview.styles';
import { PdfPreview } from './PdfPreview';
import { TextPreview } from './TextPreview';

import { useActivityPreview } from '@/hooks';
import { useActivityDetail } from '@/store';

const TOP_MARGIN = 20;

export const ActivityPreview = () => {
  const { t } = useTranslation(['CourseTranslations', 'DefaultTranslations']);
  const { activityId, setActivityId } = useActivityPreview();
  const { isLoading, activity } = useActivityDetail(activityId);

  const handleCancel = () => setActivityId();

  if (isLoading || !activity?.resource) return null;

  const { type, name, description, resource } = activity;

  const WIDTH = type === 'PDF' ? 800 : undefined;

  return (
    <Modal
      width={WIDTH}
      destroyOnHidden
      open={!!activity}
      onCancel={handleCancel}
      style={{ top: TOP_MARGIN }}
      title={t('CourseTranslations:PREVIEW_ACTIVITY_TITLE')}
      footer={
        <Button type="primary" onClick={handleCancel}>
          {t('DefaultTranslations:CLOSE')}
        </Button>
      }>
      <h4>{name}</h4>
      <Wrapper>
        {type === EActivityType.VIDEO && <VideoPlayer file={resource.file} />}
        {type === EActivityType.PDF && <PdfPreview file={resource.file} />}
        {type === EActivityType.DELIVERABLE && <PdfPreview file={resource.file} />}
        {type === EActivityType.TEXT && <TextPreview text={resource.text} />}
        <Description>{description}</Description>
      </Wrapper>
    </Modal>
  );
};
